module.exports = __webpack_public_path__ + "img/avatar-default.69db1a1a.svg";